import React, { FC, useState } from 'react';
import cn from 'classnames';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';

import trns from './trns';
import ShowMore from '../../../../shared-components/ShowMore/ShowMore';
import useGTAG from '../../../../hooks/useGTAG';
import TextButton from '../../../../shared-components/design-system/TextButton';

export const SeoTextContainerId = 'seoTextContainerId';

const SeoTextContainer: FC = () => {
  const [isBlur, setBlur] = useState(true);
  const [isTitle, setStatusTitle] = useState(true);
  const divStyle = {
    color: '#004664'
  };
  const { trackGtagEvent } = useGTAG();

  const handlerShowLess = (value) => {
    if (value) {
      trackGtagEvent('main_seotext_unfold');
    } else {
      trackGtagEvent('main_seotext_fold');
    }
    setStatusTitle(!value);
    setBlur(!value);
  };
  return (
    <div className={cn('p-4 lm:flex lm:py-10')} id={SeoTextContainerId}>
      <Constraints className="w-full pb-6">
        {isTitle && (
          <h1 className="uppercase text-astronautBlue fs-header3-bold">
            <FormattedMessage {...trns.seoContainerTitle} />
          </h1>
        )}
        <ShowMore
          showLines={6}
          showMore={
            <div className="flex relative w-full justify-center items-center pt-6">
              <div
                className={cn(
                  isBlur &&
                    'w-full from-white bg-gradient-to-t from-white h-6 absolute -top-6'
                )}
              >
                <TextButton
                  buttonLabel={<FormattedMessage {...trns.showMoreTitle} />}
                  className="mx-auto relative bottom-[-40px]"
                />
              </div>
            </div>
          }
          showLess={
            <TextButton
              buttonLabel={<FormattedMessage {...trns.showLessTitle} />}
              className="mx-auto pt-6"
            />
          }
          handlerShowLessClick={handlerShowLess}
          isExtendedFunction={true}
        >
          {!isTitle && (
            <h1
              style={divStyle}
              className="uppercase text-astronautBlue fs-header4-bold py-6"
            >
              <FormattedMessage {...trns.seoContainerTitle} />
            </h1>
          )}
          <p>
            <FormattedMessage {...trns.seoTextHome1} />
          </p>
          <br />
          <p>
            <FormattedMessage {...trns.seoTextHome2} />
          </p>
          <p>
            <FormattedMessage {...trns.seoTextHome3} />
          </p>
          <br />
          <h3
            style={divStyle}
            className="uppercase text-astronautBlue fs-header5-bold py-6"
          >
            <FormattedMessage {...trns.seoTextHome4} />
          </h3>
          <br />
          <p>
            <FormattedMessage {...trns.seoTextHome5} />
            <br />
            <FormattedMessage {...trns.seoTextHome6} />
            <br />
            <FormattedMessage {...trns.seoTextHome7} />
            <br />
            <FormattedMessage {...trns.seoTextHome8} />
          </p>
          <h2
            style={divStyle}
            className="uppercase text-astronautBlue fs-header4-bold py-6"
          >
            <FormattedMessage {...trns.seoTextHome9} />
          </h2>
          <p>
            <FormattedMessage {...trns.seoTextHome10} />
            <br />
            <FormattedMessage {...trns.seoTextHome11} />
            <br />
            <FormattedMessage {...trns.seoTextHome12} />
            <br />
            <FormattedMessage {...trns.seoTextHome13} />
            <br />
            <FormattedMessage {...trns.seoTextHome14} />
            <br />
            <FormattedMessage {...trns.seoTextHome15} />
            <br />
            <FormattedMessage {...trns.seoTextHome16} />
            <br />
            <FormattedMessage {...trns.seoTextHome17} />
            <br />
            <FormattedMessage {...trns.seoTextHome18} />
            <br />
            <FormattedMessage {...trns.seoTextHome19} />
          </p>
          <p>
            <FormattedMessage {...trns.seoTextHome20} />
          </p>
        </ShowMore>
      </Constraints>
    </div>
  );
};

export default SeoTextContainer;
